import React from 'react';
import tw from 'twin.macro';
import { css } from '@emotion/react';

import { PlayerMode } from '$/components/WebinarPlayer/types';
import { withWebinarPlayerContext } from '$/components/WebinarPlayer/context';
import { FilledMarkdown } from '$/components/ui/EditableInput/DangerouslySetInnerHTML';

import { useSendPrivateMessage } from './useSendPrivateMessage';

import { useCardContext } from '../cards/CardContext';

export const PrivateMessageCard: React.FC<{
  onClickHeader?: () => void;
}> = withWebinarPlayerContext(['attendee', 'mode', 'ewebinar', 'playbackPositionRef', 'locale'])(({
  context: webinarPlayerContext,
}) => {
  const { interaction } = useCardContext();
  const { attendee, mode, ewebinar, playbackPositionRef, locale } = webinarPlayerContext;

  useSendPrivateMessage(interaction, attendee, {
    ewebinar,
    mode,
    playbackPositionRef,
    locale,
  });

  if (mode === PlayerMode.edit) {
    return (
      <>
        <div
          className='text-chat px-1e py-1'
          css={css`
            ${tw`
              flex flex-col justify-center items-start p-3/4e m-2
              border border-chat-bubble bg-white text-color-cardText
            `}
            border-radius: 1rem;
            border-top-left-radius: 0 !important;
          `}
        >
          <FilledMarkdown md={interaction.description()} />
        </div>
        <div className={`text-sm text-black px-3/4e py-1 rounded-full w-full text-center`}>
          Attendee will see message in the chat box
        </div>
      </>
    );
  }

  // Do not render anything for attendee in Interaction stream
  return null;
});
